import React, { useEffect, useState } from "react";
import interiorLibraryAdminApi from "../../services/interiorLibraryAdminApi";

export default function ProjectMaterialPresetPanel({
  projectParameters,
  setProjectParameters,
}) {
  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    async function loadMaterials() {
      const res = await interiorLibraryAdminApi.listMaterials();
      setMaterials(res.items || []);
    }

    loadMaterials();
  }, []);

  function updateProjectParam(key, value) {
    setProjectParameters((prev) => ({
      ...prev,
      [key]: value ? Number(value) : "",
    }));
  }

  function materialSelect(label, key) {
    return (
      <div>
        <label className="text-xs text-slate-500">{label}</label>
        <select
          value={projectParameters?.[key] || ""}
          onChange={(e) => updateProjectParam(key, e.target.value)}
          className="w-full px-2 py-1 border rounded text-sm bg-white"
        >
          <option value="">Select material...</option>
          {materials.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Project materials</div>
        <div className="text-xs text-slate-500">
          Designer bira osnovne materijale. Kant i debljine kasnije izvlačimo iz baze materijala.
        </div>
      </div>

      {materialSelect("Corpus", "corpusBoardMaterialId")}
      {materialSelect("Front", "frontBoardMaterialId")}
      {materialSelect("Back", "backBoardMaterialId")}
      {materialSelect("Shelves", "shelfBoardMaterialId")}
    </div>
  );
}